module.exports = __webpack_public_path__ + "img/72eb7fa.png";